module.exports = __webpack_public_path__ + "static/media/mongoDB2.ecc6f9e5.webp";